export default __webpack_public_path__ + "static/media/info-icon-blue.a7523ba2.svg";